import {
  NOTIFICATIONS_REQUEST,
  NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_ERROR,

  NOTIFICATIONS_SEEN_REQUEST,
  NOTIFICATIONS_SEEN_SUCCESS,
  NOTIFICATIONS_SEEN_ERROR,
} from "../actions/notifications";
import HTTP from "@/utils/http";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = {
  notifications: [],
  notifications_get_status: "",
  notifications_seen_status: "",
  notifications_once_loaded: false,
};

const getters = {
  getNotifications: state => state.notifications,
  isNotificationsLoading: state => state.notifications_get_status === 'loading',
  isNotificationsFailed: state => state.notifications_get_status === 'error',
  isNotificationsSeenLoading: state => state.notifications_seen_status === 'loading',
  isNotificationsSeenFailed: state => state.notifications_seen_status === 'error',
  notificationsOnceLoaded: state => state.notifications_once_loaded,
  newNotificationsCount: state => state.notifications.filter(n => !n.seen_date).length,
};

const actions = {
  [NOTIFICATIONS_REQUEST]: ({ commit, dispatch }) => {
    commit(NOTIFICATIONS_REQUEST);
    HTTP({ url: "notifications" })
      .then(resp => {
        commit(NOTIFICATIONS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(NOTIFICATIONS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [NOTIFICATIONS_SEEN_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(NOTIFICATIONS_SEEN_REQUEST);
      HTTP({ url: "notifications", data: req /*notification_id*/, method: "POST" })
        .then(resp => {
          commit(NOTIFICATIONS_SEEN_SUCCESS, req.notification_id);
          resolve(resp);
        })
        .catch(err => {
          commit(NOTIFICATIONS_SEEN_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
};

const mutations = {
  [NOTIFICATIONS_REQUEST]: state => {
    state.notifications_get_status = "loading";
  },
  [NOTIFICATIONS_SUCCESS]: (state, data) => {
    state.notifications_get_status = "success";
    Vue.set(state, "notifications", data);
    state.notifications_once_loaded = true;
  },
  [NOTIFICATIONS_ERROR]: state => {
    state.notifications_get_status = "error";
    state.notifications_once_loaded = true;
  },

  [NOTIFICATIONS_SEEN_REQUEST]: state => {
    state.notifications_seen_status = "loading";
  },
  [NOTIFICATIONS_SEEN_SUCCESS]: (state, notification_id) => {
    console.log('trying to update notification ' + notification_id);
    state.notifications_seen_status = "success";
    for (let i = 0; i < state.notifications.length; i++) {
      const n = state.notifications[i];
      if (n.id === notification_id) {
        console.log('updated notification ' + notification_id);
        let new_notification = Object.assign({},n);
        new_notification.seen_date = new Date().toISOString();
        state.notifications.splice(i, 1, new_notification)
      }
    }
  },
  [NOTIFICATIONS_SEEN_ERROR]: state => {
    state.notifications_seen_status = "error";
  },

  [AUTH_LOGOUT]: state => {
    state.notifications = [];
    state.notifications_get_status = "";
    state.notifications_seen_status = "";
    state.notifications_once_loaded = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};